import { render, staticRenderFns } from "./accountForm.vue?vue&type=template&id=2cc529ae&"
import script from "./accountForm.vue?vue&type=script&lang=js&"
export * from "./accountForm.vue?vue&type=script&lang=js&"
import style0 from "./accountForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports